import React, { Component } from "react";
import { BeautifulDialog, DialogContent } from "../../../react/components/Dialogs/BaseDialog";
import { DialogTitle, DialogActions } from "@material-ui/core";
import { AiImageStyleTypes, ImageStyles } from "../../../../common/aiConstants";
import { Button } from "../../../Components/Button";
import { TextField } from "../../../Components/TextField";
import styled from "styled-components";
import { themeColors } from "../../../react/sharedStyles";
import { AiImageStyle, AiImageStylePopup } from "./AiImageStyle";
import { FlexSpacer, Gap10, Gap20 } from "../../../react/components/Gap";
import { SimpleLabel } from "../../../react/components/SimpleLabel";
import { Icon } from "../../../Components/Icon";
import { FlexBox } from "../../../react/components/LayoutGrid";
import AiGenerationService from "../../../core/services/aiGeneration";
import Spinner from "../../../react/components/Spinner";

const PromptContainer = styled.div`
    position: relative;
    min-height: 80px;
`;

export class RegenerateImageDialog extends Component {
    constructor(props) {
        super(props);

        this.state = {
            prompt: props.prompt,
            imageStyle: props.imageStyle,
            isGeneratingPrompt: false
        };
    }

    handleRegeneratePrompt = async () => {
        const { currentSlide } = this.props;

        this.setState({ isGeneratingPrompt: true });

        let results = await AiGenerationService.generateSlideImagePrompt(
            currentSlide.getMetadata().slidePrompt,
            currentSlide.presentation.get("metadata").topic
        );

        this.setState({ isGeneratingPrompt: false });

        if (results) {
            this.setState({ prompt: results.slideImagePrompt });
        }
    }

    render() {
        const { prompt, imageStyle, isGeneratingPrompt } = this.state;
        const { theme, closeDialog } = this.props;

        return (
            <BeautifulDialog
                PaperProps={{ style: { maxWidth: 850 } }}
                closeDialog={closeDialog}
            >
                <DialogTitle>Regenerate Image</DialogTitle>

                <DialogContent>
                    <FlexBox left middle>
                        <SimpleLabel>PROMPT</SimpleLabel>
                        <FlexSpacer />
                        <Button unframed onClick={this.handleRegeneratePrompt}>
                            <Icon>lightbulb</Icon>Suggest a different prompt
                        </Button>
                    </FlexBox>
                    <PromptContainer>
                        {isGeneratingPrompt && <Spinner />}
                        {!isGeneratingPrompt && (
                            <TextField variant="outlined" multiline fullWidth
                                value={prompt} onChange={value => this.setState({ prompt: value })}
                                onEnterKeyPress={() => {
                                    closeDialog({ imagePrompt: prompt, imageStyle });
                                }}
                                style={{ background: "white", userSelect: "text" }}
                            />
                        )}
                    </PromptContainer>

                    <Gap20 />
                    <AiImageStyle theme={theme} imageStyle={imageStyle} thumbnailSize={90}
                        onChange={imageStyle => this.setState({ imageStyle })}
                    />
                </DialogContent>

                <DialogActions>
                    <Button unframed onClick={closeDialog}>Cancel</Button>
                    <Button blue onClick={() => {
                        closeDialog({ imagePrompt: prompt, imageStyle });
                    }} disabled={isGeneratingPrompt || prompt.trim().length === 0}>Regenerate Image</Button>
                </DialogActions>

            </BeautifulDialog>
        );
    }
}

